import React, { Component } from "react";
import { connect } from "react-redux";
import {
  getReferenceList,
  selectAddMember
} from "../../../state/ducks/loyalty/index";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-bootstrap.css";
import $ from "jquery";
String.prototype.turkishtoEnglish = function () {
  return this.replaceAll('Ğ', 'g')
    .replaceAll('Ü', 'u')
    .replaceAll('Ş', 's')
    .replaceAll('I', 'i')
    .replaceAll('İ', 'i')
    .replaceAll('Ö', 'o')
    .replaceAll('Ç', 'c')
    .replaceAll('ğ', 'g')
    .replaceAll('ü', 'u')
    .replaceAll('ş', 's')
    .replaceAll('ı', 'i')
    .replaceAll('ö', 'o')
    .replaceAll('ç', 'c');
};
export class MyReferences extends Component {
  constructor(props) {
    super(props);
    this.state = {
      columnDefs: [
        {
          headerName: "Adı Soyadı",
          field: "adi",
          sortable: true,

          suppressSizeToFit: true,
          unSortIcon: true
        },
        {
          headerName: "Durumu",
          field: "durum",
          sortable: true,

          suppressSizeToFit: true,
          unSortIcon: true
        },
        {
          headerName: "Geçerlilik Süresi",
          field: "gecerlilikSuresi",
          sortable: true,

          suppressSizeToFit: true,
          unSortIcon: true,
          valueFormatter: dayFormatter
        }
      ],
      localeText: {
        page: "Sayfa",
        contains: "İçeren",
        notContains: "İçermeyen",
        of: " / ",
        to: "ile",
        equals: "Eşit",
        notEqual: "Eşit Değil",
        startsWith: "Başlar",
        endsWith: "Biter",
        noRowsToShow: "Referans bulunamadı.",
        loadingOoo: "Yükleniyor..."
      }
    };
  }

  state = {
    references: []
  };

  onGridReady = params => {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
  };

  componentWillReceiveProps(nextProps) {
    this.setState({
      references: nextProps.loyalty.references
    });
  }

  componentDidMount() {
    this.props.getReferenceList();
    $(".ag-paging-row-summary-panel").html($("#totalRowCount"));
  }

  pageCountChange = event => {
    let value = event.target.value;
    this.gridApi.paginationSetPageSize(Number(value));
  };

  filterList = event => {
    let value = event.target.value.turkishtoEnglish().toLowerCase();
    let referencesList = [];
    if (value === "") {
      this.setState({
        references: this.props.loyalty.references
      });
      return;
    }
    if (this.state.references.length === 0) {
      referencesList = this.props.loyalty.references;
    }
    else {

      referencesList = this.state.references;
    }
    let result = referencesList.filter(item => {
      return (
        item?.adi?.turkishtoEnglish().toLowerCase().search(value) !== -1 ||
        item?.durum?.turkishtoEnglish().toLowerCase().search(value) !== -1 ||
        item?.gecerlilikSuresi.toString().turkishtoEnglish().toLowerCase().search(value) !== -1
      );
    });
    this.setState({ references: result });
  };

  render() {
    return (
      <>
        <div className="container-fluid">
          {/* yesil Alan*/}
          <div className="row" style={{ padding: "3%" }}>
            <div className="col-12">
              {/* KUTU 1 */}
              <div className="row no-gutters t-kutu t-turuncuCizgi">
                <div className="col bosluk backtop" style={{
                  backgroundImage:
                    'url("/assets/img/backgrounds/back_top_turuncu.jpg")'
                }}>
                  {/* içerikler */}
                  {/* Başlık */}
                  <div className="row no-gutters pb-4">
                    <div clss="col-auto">
                      <i className="t-icon-user-check icon" />
                    </div>
                    <div className="col d-flex flex-column justify-content-center">
                      <div className="baslik" style={{ padding: "0 0 5px 0" }}>
                        Referanslarım
                      </div>
                      <span className="altBaslik">Onaylı Referanslarım</span>
                    </div>
                  </div>
                  <div className="row no-gutters">
                    {/* Arama*/}
                    <div className="col-10 pb-4">
                      <form className="form-inline">
                        <input
                          className="form-control mr-sm-2 rounded-pill"
                          type="search"
                          placeholder="Arama yapın..."
                          onChange={this.filterList}
                        />
                        {/* <button
                          className="btn btn-outline-success my-2 my-sm-0 rounded-pill"
                          type="button"

                        >
                          Referans Ara
                        </button> */}

                      </form>


                    </div>
                    <div className="col-2 pb-4">
                      <div className="t-icInput">
                        <div>
                        </div>
                        <select
                          className="custom-select"
                          onChange={this.pageCountChange}
                        >
                          <option value="10">10</option>
                          <option value="20">20</option>
                          <option value="50">50</option>
                          <option value="100">100</option>
                        </select>
                        <div />
                      </div>
                    </div>
                    {/* Tablo*/}
                    <div className="col-12">

                      <div
                        className="ag-theme-bootstrap t-tablo"
                        style={{
                          width: "100%",
                          height: "500px"
                        }}
                      >
                        <AgGridReact
                          columnDefs={this.state.columnDefs}
                          rowData={this.state.references}
                          pagination={true}
                          paginationPageSize={10}
                          localeText={this.state.localeText}
                          rowHeight={30}
                          headerHeight={30}
                          animateRows={true}
                          onGridReady={this.onGridReady}
                        ></AgGridReact>
                      </div>
                      <span className="float-right" id="totalRowCount">
                        Toplam Referans: <strong>{this.state?.references?.length}</strong>
                      </span>
                    </div>
                  </div>
                  {/* içerikler BİTTİ */}
                </div>
                <div className="col-auto renk" />
              </div>
              {/* KUTU 1 BİTTİ */}
            </div>
          </div>
          {/* Duyurlar Baslık*/}
          {/* duyrular Bitti*/}
          <div className="row" style={{ height: 30 }} />
        </div>

      </>
    );
  }
}

function dayFormatter(params) {
  return params.value + " Gün";
}

const mapStateToProps = state => {
  return {
    loyalty: selectAddMember(state)
  };
};

const mapDispatchToProps = dispatch => ({
  getReferenceList: () => dispatch(getReferenceList())
});

export default connect(mapStateToProps, mapDispatchToProps)(MyReferences);
